<template>

    <data-table
      :title="tableTitle"
      titleHeading="h4"
      table-ref="checklisttable"
      :show-search="false"
      :url="url + `/checklist/${parentData.id}`"
      v-bind:fields="listFields"
      sort-field="id"
      :add-action="isSiteManager ? (percentComplete < 100 ? addActionComp : null) : null"
      :add-props="addProps">


      <template slot="name" slot-scope="props">
        <span v-if="props.rowData.name && props.rowData.category"><b class="text-primary">{{props.rowData.name}}</b> <small>({{props.rowData.category}})</small></span>
        <span v-else class="text-primary">{{props.rowData.name}}</span>
      </template>



      <template slot="time" slot-scope="props">
        <strong v-if="props.rowData.taskTime && props.rowData.taskUnits" class="text-primary">{{props.rowData.taskTime}} {{plural(props.rowData.taskUnits, props.rowData.taskTime)}}</strong>
        <span v-else>-</span>
      </template>



      <template slot="status" slot-scope="props">
        <span v-if="props.rowData.status === 'Finished'" class=" text-success"><i class="fa fa-flag-checkered" />&nbsp;{{props.rowData.status}}</span>
        <span v-if="props.rowData.status === 'In Progress'" class=" text-primary"><i class="fa fa-spinner fa-spin" />&nbsp;{{props.rowData.status}}</span>
        <span v-if="props.rowData.status === 'KIV'" class="text-danger"><i class="fa fa-minus" />&nbsp;{{props.rowData.status}}</span>
        <span v-if="props.rowData.status === 'Escalated'" class="text-warning"><i class="fa fa-plus" />&nbsp;{{props.rowData.status}}</span>
        <span v-if="props.rowData.status === 'Pending'" class="text-info"><i class="fa fa-clock" />&nbsp;{{props.rowData.status}}</span>
        <span v-if="props.rowData.grading && props.rowData.status === 'Finished'">
          <el-rate
            v-model="props.rowData.grading"
            :disabled="true"
            :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
          />
        </span>
      </template>


      <template slot="photo" slot-scope="props">
        <div v-if="isSite">
        <el-button
        v-if="props.rowData.photoRequired"
        :type="props.rowData.files === 2 ? 'success' : (props.rowData.files === 1 ? 'warning' : 'danger' )"
         size="mini"
         disabled>
         <i :class="props.rowData.photoRequired ? 'fa fa-camera' : ''"></i>
       </el-button>
        </div>
        <div v-else>
          <i :class="props.rowData.photoRequired ? 'fa fa-check' :''"></i>
        </div>
      </template>



      <template slot="edit" slot-scope="props">
          <edit-checklist v-if="props.rowData.status !== 'Finished'"
              :row-data="props.rowData"
              :parent-id="props.rowData.parent_id"
              :workflow-id="props.rowData.workflow_id"
              :site-id="props.rowData.site_id"
              :is-site="isSite"
               />
          <div v-else>
            <edit-checklist v-if="props.rowData.site_id" :row-data="clone(props.rowData)" is-view :is-site="isSite"  />
          </div>
      </template>



      <template slot="delete" slot-scope="props">
          <el-button
            v-if="props.rowData.status !== 'Finished' && isManager()"
            size="mini"
            type="danger"
            circle
            @click="onDelete(props.rowData)">
            <i class="fa fa-trash"></i>
        </el-button>
      </template>

    </data-table>

</template>

<script>

import WorkflowMixins from '@/mixins/WorkflowMixins'

import EditChecklist from '@/components/workflow/checklist/EditChecklist'


export default {
  mixins: [WorkflowMixins],

  components: {
    EditChecklist
  },

  props: {
    parentData: {
      type: Object,
      required: true
    },

    isSite: {
      type: Boolean,
      default: false
    },

    percentComplete: {
      type: Number,
      default: 0
    },

    tableTitle: {
      type: String,
      default: 'Checklist'
    }
  },


  methods: {

    onDelete (row) {
      this.deleteItem(this,
        row.id,
        this.url,
        (row.name ? row.name : 'Checklist Item'),
        null,
        true,
        (this.isSite ? [this.CHECKLIST_TABLE_REF, this.SITE_WORKFLOW_TABLE_REF] : [this.CHECKLIST_TABLE_REF, this.WORKFLOW_TABLE_REF]))
    }
  },

  data () {
    return {
      url: (this.isSite ? 'workflow/sites' : 'workflow'),
      grading: null,
      addActionComp: EditChecklist,
      addProps: {
        parentData: (this.parentData ? this.parentData : (this.isSite ? this.getTableStruct('site_workflow') : this.getTableStruct('workflow'))),
        rowData: (this.isSite ? this.getTableStruct('site_workflow') : this.getTableStruct('workflow')),
        parentId: this.parentData.id,
        workflowId: (this.isSite ? this.parentData.workflow_id : this.parentData.id),
        siteId: this.isSite ? this.parentData.site_id : null,
        isSite: this.isSite,
        isAdd: true
      },

      listFields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'id'
        },
        {
          title: '<i class="fa fa-tasks"></i> Tasks',
          name: '__slot:name'
        },
        {
          title: '<i class="fa fa-users"></i> Staff',
          name: 'workforceReq',
          visible: this.isSite,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          title: '<i class="fa fa-clock"></i> Task Time',
          name: '__slot:time',
          visible: this.isSite
        },
        {
          title: '<i class="fa fa-clipboard-list"></i> Status',
          name: '__slot:status',
          visible: this.isSite
        },
        {
          title: '<i class="fa fa-camera"></i> Photo',
          name: '__slot:photo'
        },
        {
          title: '<i class="fa fa-asterisk"></i> Actions',
          name: '__slot:edit'
        },
        {
          name: '__slot:delete'
        }
      ]
    }
  },

  created () {

    if (isNaN(this.percentComplete)) {
      this.percentComplete = null
    }

  }
}
</script>



// WEBPACK FOOTER //
// ChecklistTable.vue?56b76fb0